import React, { memo, useCallback, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import styles from './WpTurnLimit5.module.less';

import { logging } from '../../actions/log';
import { updateShowWpTurnLimit, updateShowWpOrder } from '../../actions/wallpaper';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectWallpaper = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper,
);

export default memo(() => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const { wpShowTurnLimit } = useSelector(selectWallpaper);

  useEffect(() => {
    loggingFunc('Wallpaper', 'P_Wallpaper_limit');
  }, []);

  const loggingFunc = useCallback(
    (category, action, param = {}) => {
      dispatch(
        logging({
          category: category || 'Wallpaper',
          action: action || 'P_Wallpaper_limit',
          label: '',
          param2: {
            source: logInfoData?.logInfo?.source,
            source_p: logInfoData?.source_p,
            source_pp: logInfoData?.source_pp,
            wallpaperId: wpShowTurnLimit?.wallpaperId,
            code: wpShowTurnLimit?.code,
            wpType: wpShowTurnLimit?.wpType || 3, // 1: 单张壁纸，2：壁纸包 3: 仅仅订阅
            ...param,
          },
        }),
      );
    },
    [logInfoData],
  );

  const handleDialogBtn = useCallback(
    flag => {
      // 点击开启轮播
      if (
        wpShowTurnLimit &&
        wpShowTurnLimit?.show &&
        wpShowTurnLimit?.callbackTurnLimit &&
        typeof wpShowTurnLimit?.callbackTurnLimit === 'function'
      ) {
        wpShowTurnLimit.callbackTurnLimit(flag);
      }
      // 点击去购买
      if (flag === 3) {
        dispatch(
          updateShowWpOrder({
            show: true,
            wallpaperId: wpShowTurnLimit?.wallpaper?.wallpaperId,
            code: '',
            wpType: 3, // 1: 单张壁纸，2：壁纸包 3: 仅仅订阅
            wallpaper: wpShowTurnLimit?.wallpaper,
            cardInfo: wpShowTurnLimit?.cardInfo,
            logInfo: wpShowTurnLimit?.logInfo,
            callbackTurnOrder: wpShowTurnLimit?.callbackTurnOrder,
            scenetype: 'loop_start', // 'set', 'dl', 'resident', 'loop_single', 'loop_batch', 'loop_start'
          }),
        );
      }

      setTimeout(() => {
        dispatch(
          updateShowWpTurnLimit({
            show: false,
          }),
        );
      }, 100);
    },
    [wpShowTurnLimit],
  );

  return (
    <div className={`${styles.dialog_box}`}>
      <div className={styles.dialog_cont}>
        <div className="dialog_header">
          <div className="dialog_header_text"></div>
          <div
            className="dialog_header_close iconfont icon-opt_close"
            onClick={() => {
              handleDialogBtn(1);
            }}
          ></div>
        </div>
        <div className="dialog_content">
          <div className="dialog_info">
            <div className="dialog_info_title">您当前仅能轮播5张免费壁纸</div>
            <div className="dialog_info_desc">开通壁纸订阅服务，全库壁纸轮播无上限</div>
          </div>
          <div className="dialog_center">
            <div className="dialog_center_title">壁纸订阅服务特权</div>
            <div className="dialog_center_powers">
              <div className="dialog_center_power">
                <div className="dialog_center_power_logo logo1"></div>
                <div className="dialog_center_power_title">全库壁纸</div>
                <div className="dialog_center_power_desc">任意用</div>
              </div>
              <div className="dialog_center_power">
                <div className="dialog_center_power_logo logo2"></div>
                <div className="dialog_center_power_title">精美壁纸</div>
                <div className="dialog_center_power_desc">随意下</div>
              </div>
              <div className="dialog_center_power">
                <div className="dialog_center_power_logo logo3"></div>
                <div className="dialog_center_power_title">4K壁纸</div>
                <div className="dialog_center_power_desc">持续上新</div>
              </div>
              <div className="dialog_center_power">
                <div className="dialog_center_power_logo logo4"></div>
                <div className="dialog_center_power_title">壁纸轮播</div>
                <div className="dialog_center_power_desc">列表无限</div>
              </div>
              <div className="dialog_center_power">
                <div className="dialog_center_power_logo logo5"></div>
                <div className="dialog_center_power_title">3端共享</div>
                <div className="dialog_center_power_desc">会员权益</div>
              </div>
            </div>
          </div>
          <div className="dialog_opt">
            <div
              className="dialog_btn_cancle"
              onClick={() => {
                handleDialogBtn(2);
              }}
            >
              开启轮播
            </div>
            <div
              className="dialog_btn_sure"
              onClick={() => {
                handleDialogBtn(3);
              }}
            >
              <span className="dialog_btn_sure_logo"></span>
              <span className="dialog_btn_sure_text">去开通</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
